"use client";

import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { BorderTrail } from "@/components/motion-primitives/border-trail";
import { cn } from "@/utils/utils";
import { JurniCoreActionRequired } from "./jurni-core-action-required";
import { ChevronRight } from "lucide-react";
import * as React from "react";

interface Props {
  completedCount: number;
  totalCount: number;
  isJurniCorePending: boolean;
}

export const GettingStartedSidebarItem = React.forwardRef<
  HTMLButtonElement,
  Props & React.ComponentPropsWithoutRef<typeof SidebarMenuButton>
>(
  (
    { completedCount, totalCount, isJurniCorePending, className, ...props },
    ref,
  ) => {
    const completionPercentage =
      totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;

    return (
      <SidebarMenuItem className="mt-2">
        <SidebarMenuButton
          ref={ref}
          {...props}
          className={cn(
            "relative h-8 justify-between overflow-hidden rounded-md border border-border bg-white hover:bg-white focus-visible:outline-none focus-visible:ring-0 active:bg-white data-[state=open]:bg-white data-[state=open]:hover:bg-white",
            className,
          )}
          tooltip="Account Setup"
        >
          <BorderTrail />
          <span className="flex items-center gap-1.5">
            Account Setup
            {isJurniCorePending && <JurniCoreActionRequired />}
          </span>
          <span className="flex items-center gap-1 text-xs text-muted-foreground">
            {completionPercentage}%
            <ChevronRight size={12} />
          </span>
        </SidebarMenuButton>
      </SidebarMenuItem>
    );
  },
);

GettingStartedSidebarItem.displayName = "GettingStartedSidebarItem";
